import { MessageCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Treatments from "@/components/Treatments";
import Pricing from "@/components/Pricing";
import WhyChoose from "@/components/WhyChoose";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import { WA_DEFAULT } from "@/lib/data";

export default function Home() {
  return (
    <main className="bg-white min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Treatments />
      <Pricing />
      <WhyChoose />
      <Reviews />
      <Contact />

      <a
        href={WA_DEFAULT}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Prenota su WhatsApp"
        className="fixed bottom-6 right-6 z-40 group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-soft-ping" aria-hidden="true" />
        <span className="relative flex w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] group-hover:bg-[#1DA851] group-hover:scale-105 transition-[background-color,transform] duration-300">
          <MessageCircle className="w-6 h-6" />
        </span>
      </a>
    </main>
  );
}
